import config from "appConfig";
import { Slide } from "@jelly/lesson";

const principle: Slide = {
  titleHtml: `<div style="text-align:center">Vehicle Sound Simulation</div>`,
  title: "Introduction",
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colSpan: {
        "0:0": 2,
      },
      colsSize: [1, 3],
      rowsSize: [1, 9],
      gap: "20px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                // alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data: "Vehicle Sound Simulation",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "In the automotive industry, auralization techniques can be used to simulate vehicle sound and to perform virtual test drives in different stages of the development process. By means of an interactive NVH (Noise, Vibration, Harshness) simulator, (audible) effects introduced by the replacement, addition or modification of individual components (e.g. the powertrain) can be assessed and validated beforehand, thereby eliminating or greatly reducing the need for expensive physical prototypes. Moreover, an auralization based simulator enables a fast comparison between different variants of a sound or even between different development states (e.g. before and after a change is introduced), enabling sound evaluations with larger groups and under reproducible conditions. Depending on the target application, the complexity and capabilities of NVH simulators can be scaled from compact desktop simulators, well-suited for typical office or laboratory environments, to full-fledged vehicle simulators with motion platforms and multimodal feedback (e.g. seat vibrations). Auralization based simulators can also be used in real vehicles and test drives by obtaining operating state variables (i.e. speed, RPM, etc.) directly from the vehicle’s CAN bus and using noise cancelling headphones to reproduce the synthesised sound. This case study will take you through the main stages and components required to create realistic and interactive vehicle sound auralizations which enable the simulation of different conditions, operating states, and components.",
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: false,
                },
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "simple",
              options: {
                components: [
                  {
                    variant: "layout",
                    data: {
                      type: "table",
                      options: {
                        cols: 2,
                        rows: 2,
                        colSpan: {
                          "0:0": 2,
                        },
                        gap: "15px",
                        components: [
                          [
                            {
                              variant: "blockContainer",
                              data: {
                                block: {
                                  type: "image",
                                  options: {
                                    src: `${config.ASSETS_URL}/03/case-02/principle/vehicle-2.png`,
                                  },
                                },
                              },
                            },
                          ],
                          [
                            {
                              variant: "blockContainer",
                              data: {
                                block: {
                                  type: "image",
                                  options: {
                                    src: `${config.ASSETS_URL}/03/case-02/principle/vehicle-1.png`,
                                  },
                                },
                              },
                            },
                            {
                              variant: "blockContainer",
                              data: {
                                block: {
                                  type: "image",
                                  options: {
                                    src: `${config.ASSETS_URL}/03/case-02/principle/vehicle-3.png`,
                                  },
                                },
                              },
                            },
                          ],
                        ],
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
